/* eslint-disable no-return-assign */
import Vue from 'vue'
import gql from 'graphql-tag'
import moment from 'moment-timezone';
import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
}

export const getters = {}

export const mutations = {
  SET_DASHBOARDS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }


  },
  SET_DASHBOARD(state, objects) {
      state.currentDashboard = objects
  },
  SET_VEHICLEDATA(state, objects) {
      state.currentVehicleData = objects
  },
  SET_DASHBOARDSTATDATA(state, objects) {
      state.currentStatData = objects
  },
  SET_EXPIRYDATA(state,objects){
    state.currentExpiryData = objects
  }
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getDashboardData({ commit }) {
    try {
      const expiryResponse = await
          graphqlClient.query({
              query: gql`
              query{
              notices{
                drivers {
                  id
                  username
                  name
                  mobile
                  email
                  drivers_licence_no
                  drivers_licence_expiry
                  emergency_contact_no
                  emergency_contact_name
                  created_at
                  updated_at
                }
                vehicles {
                  id
                  number_plate
                  capacity
                  created_at
                  active
                  vehicle_registration_expiry
                }
                service_agreements {
                  id
                  gate_access_method
                  notes
                  agreement_commencement_date
                  agreement_end_date
                  client{
                    id
                    client_name
                  }
                }
              }
              }
        `,
          })
          expiryResponse.data.notices.service_agreements.forEach(item => item.agreement_end_date  = moment(item.agreement_end_date).format('MMM Do YYYY'))
          expiryResponse.data.notices.vehicles.forEach( vehicle => vehicle.vehicle_registration_expiry  = moment(parseInt(vehicle.vehicle_registration_expiry)).format('MMM Do YYYY') );
      const response = await
          graphqlClient.query({
              query: gql`
              query{
                getCollectionData{
                  service_types{
                    id
                    name
                    capacity
                  }
              		collections{
                    id
                    service_type{
                      id
                      name
                      capacity
                    }
                    completed
                  }
                }
              }
        `,
          })
        const vehicleResponse = await
              graphqlClient.query({
                  query: gql`
                  query{
                    getVehicleData
                  }
                    `,
              })
              const unassignedResponse = await
                      graphqlClient.query({
                          query: gql`
                          query{
                            getUnassignedCollectionData
                          }
                                `,
                          })

        graphqlClient.cache.reset()

        commit('SET_DASHBOARD', response.data.getCollectionData)
        commit('SET_VEHICLEDATA', JSON.parse(vehicleResponse.data.getVehicleData))
        commit('SET_DASHBOARDSTATDATA', JSON.parse(unassignedResponse.data.getUnassignedCollectionData))
        commit('SET_EXPIRYDATA',expiryResponse.data.notices)

    } catch (ex) {
      throw ex
    }
  },



}
